export default __webpack_public_path__ + "15d0b86c3e3d898db1d6e4a7e47d8af7.png";